const config = {
  plataforma: true,
};

export default config;
